import { activationCodeField, defaultSignUpFields, linkedInField } from './questions.shared';
import { OnboardingQuestion } from '../onboarding.types';

type EmployerQuestionKey = 'WHAT_DO_YOU_DO' | 'YOUR_OBJECTIVE' | 'CREATE_ACCOUNT' | 'RECRUITMENT';

export const EMPLOYER_QUESTIONS = (): Record<EmployerQuestionKey, OnboardingQuestion> => {
  return {
    WHAT_DO_YOU_DO: {
      title: 'What do you do?',
      subTitle: 'Select any that apply',
      featuredIcon: 'User01',
      onComplete: 'CONTINUE_WITHOUT_SUBMIT',
      question: {
        type: 'CHECKBOX',

        profile_option_category_id: 'onboarding',
        profile_option_question_id: 'what_do_you_do',
        profile_option_source: 'onboarding',

        rules: {
          required: 'Please select at least one option',
        },
        options: [
          { label: 'Human Capital', value: 'employer_human_capital' },
          { label: 'Recruiting', value: 'employer_recruiting' },
          { label: 'Community/Social Impact', value: 'employer_community_social_impact' },
          { label: 'Management', value: 'employer_management' },
          { label: 'Other', value: 'employer_other' },
        ],
      },
    },
    YOUR_OBJECTIVE: {
      title: 'Your objective',
      subTitle: 'How can Backrs help you as an employer?',
      featuredIcon: 'Target04',
      onComplete: 'CONTINUE_WITHOUT_SUBMIT',

      question: {
        type: 'CHECKBOX',

        profile_option_category_id: 'onboarding',
        profile_option_question_id: 'your_objective',
        profile_option_source: 'onboarding',

        rules: {
          required: 'Please select at least one option',
        },
        options: [
          {
            label: 'Build a reliable early-career talent pipeline',
            value: 'employer_talent_pipeline',
          },
          { label: 'Enhance your brand among young talent', value: 'employer_brand_among_talent' },
          {
            label: 'Reduce hiring and/or training costs',
            value: 'employer_reduce_hiring_training_costs',
          },
          {
            label: 'Strengthen community and social impact',
            value: 'employer_strengthen_community',
          },
          { label: 'Innovate', value: 'employer_innovate' },
        ],
      },
    },
    CREATE_ACCOUNT: {
      title: 'Create an account',
      subTitle: 'Sign up in less than 2 minutes.',
      featuredIcon: 'UserCircle',
      onComplete: 'SUBMIT_USER_INFO',
      question: {
        type: 'FORM',
        fields: defaultSignUpFields,
      },
    },
    RECRUITMENT: {
      title: 'Recruitment',
      subTitle: 'Please share all the paths where your company recruits early career talent',
      featuredIcon: 'Dataflow01',
      onComplete: 'POST_PROFILE_OPTION_ANSWER',
      question: {
        type: 'FORM',
        fields: [
          {
            name: 'CAREER_PATH_DROPDOWNS',
          },
          activationCodeField,
          linkedInField,
        ],
      },
    },
  };
};

export const QUESTION_INDEX_TO_FIELDS_EMPLOYER: Record<number, string[]> = {
  0: ['what_do_you_do'], // WHAT_DO_YOU_DO
  1: ['your_objective'], // YOUR_OBJECTIVE
  2: ['first_name', 'last_name', 'phone', 'email', 'password'], // CREATE_ACCOUNT
  3: ['career_path_category', 'career_path_subcategory', 'career_path_field', 'invite_code'], // RECRUITMENT
};
